module.exports = __webpack_public_path__ + "static/media/13-Ochoa.eb947359.png";